<template>
  <div class="xscontainer jsjiesh">
    <div class="nnklcv">
      <SearchBox @search="chaxunSuoyou"></SearchBox>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="行业快讯" name="1">
          <div class="neewre" v-for="(item, index) in hangyekuaixuns" @click="gotoXiangqing(item.id,activeName)">
            <p class="zhengwen_grey1" >{{item.biaoti}}</p>
            <p class="zhengwen_grey1 ">{{item.shijian}}</p>
          </div>
          <el-pagination
              align="center"
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="currentPage1"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pagesize1"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total1">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="经验杂谈" name="2">
          <div class="neewre" v-for="(item, index) in jingyanzatans" @click="gotoXiangqing(item.id,activeName)">
            <p class="zhengwen_grey1" >{{item.biaoti}}</p>
            <p class="zhengwen_grey1 ">{{item.shijian}}</p>
          </div>
          <el-pagination
              align="center"
              @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2"
              :current-page="currentPage2"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pagesize2"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total2">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="知识普及" name="3">
          <div class="neewre" v-for="(item, index) in zspjs" @click="gotoXiangqing(item.id,activeName)">
            <p class="zhengwen_grey1" >{{item.biaoti}}</p>
            <p class="zhengwen_grey1 ">{{item.shijian}}</p>
          </div>
          <el-pagination
              align="center"
              @size-change="handleSizeChange3"
              @current-change="handleCurrentChange3"
              :current-page="currentPage3"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pagesize3"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total3">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="dsfsdfg" v-model="fwcishu">【访问次数:{{fwcishu}}】</div>
  </div>
</template>

<script>
import SearchBox from "@/components/lianmeng/common/SearchBox";
export default {
  components:{SearchBox},
  data() {
    return {
      zspjs:[],
      jingyanzatans:[],
      hangyekuaixuns:[],
      activeName: '',
      pagesize1:10,
      pagesize2:10,
      pagesize3:10,
      currentPage1: 1,
      currentPage2: 1,
      currentPage3: 1,
      total1:0,
      total2:0,
      total3:0,
      currentText:'',
      fwcishu:0
    };
  },
  mounted() {
    this.queryZspj();
    this.queryHyfx();
    this.queryJyzt();
    debugger
    let params = this.$route.query;
    let type = params.type;
    if(type){
      this.activeName = type;
    }else{
      this.activeName = '1';
    }
  },
  created() {
    this.tongji('文本知识');
  },
  methods:{
    tongji(caidan) {
      var that = this;
      this.$ajax
          .post(this.GLOBAL.sys_addr + '/tongji/tTongji/tj', {caidan: caidan})
          .then(function (response) {
            if (response.status == 200) {
              that.fwcishu = response.data;
            }
          });
    },
    chaxunSuoyou(stext){
      this.currentText = stext;
      this.queryZspjLike(stext);
      this.queryHyfxLike(stext);
      this.queryJyztLike(stext);
    },
    queryZspjLike(stext){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/wenben/tWenben/list?_t='+new Date().getTime()+'&column=paixu&order=desc&field=id,biaoti,action&biaoti=*'+stext+'*&fenlei=知识普及&pageNo='+this.currentPage3+'&pageSize='+this.pagesize3)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.zspjs  = response.data.result.records;
              that.currentPage3 = response.data.result.current;
              that.total3 = response.data.result.total;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    },
    queryJyztLike(stext){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/wenben/tWenben/list?_t='+new Date().getTime()+'&column=paixu&order=desc&field=id,biaoti,action&biaoti=*'+stext+'*&fenlei=经验杂谈&pageNo='+this.currentPage2+'&pageSize='+this.pagesize2)
          .then(function (response) {
            if (response.data.code == 200) {
              that.jingyanzatans  = response.data.result.records;
              that.currentPage2 = response.data.result.current;
              that.total2 = response.data.result.total;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    },
    queryHyfxLike(stext){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/wenben/tWenben/list?_t='+new Date().getTime()+'&column=paixu&order=desc&field=id,biaoti,action&biaoti=*'+stext+'*&fenlei=行业快讯&pageNo='+this.currentPage1+'&pageSize='+this.pagesize1)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.hangyekuaixuns  = response.data.result.records;
              that.currentPage1 = response.data.result.current;
              that.total1 = response.data.result.total;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    },
    handleClick(){

    },
    handleSizeChange1(val) {
      this.pagesize1 = val;
      if(this.currentText){
        this.queryHyfxLike(this.currentText);
      }else{
        this.queryHyfx();
      }

    },
    handleSizeChange2(val) {
      this.pagesize2 = val;

      if(this.currentText){
        this.queryJyztLike(this.currentText);
      }else{
        this.queryJyzt();
      }
    },
    handleSizeChange3(val) {
      this.pagesize3 = val;
      if(this.currentText){
        this.queryZspjLike(this.currentText);
      }else{
        this.queryZspj();
      }
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      if(this.currentText){
        this.queryHyfxLike(this.currentText);
      }else{
        this.queryHyfx();
      }
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      if(this.currentText){
        this.queryJyztLike(this.currentText);
      }else{
        this.queryJyzt();
      }
    },
    handleCurrentChange3(val) {
      this.currentPage3 = val;
      if(this.currentText){
        this.queryZspjLike(this.currentText);
      }else{
        this.queryZspj();
      }
    },
    queryZspj(){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/wenben/tWenben/list?_t='+new Date().getTime()+'&column=paixu&order=desc&field=id,biaoti,action&fenlei=知识普及&pageNo='+this.currentPage3+'&pageSize='+this.pagesize3)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.zspjs  = response.data.result.records;
              that.currentPage3 = response.data.result.current;
              that.total3 = response.data.result.total;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    },
    queryJyzt(){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/wenben/tWenben/list?_t='+new Date().getTime()+'&column=paixu&order=desc&field=id,biaoti,action&fenlei=经验杂谈&pageNo='+this.currentPage2+'&pageSize='+this.pagesize2)
          .then(function (response) {
            if (response.data.code == 200) {
              that.jingyanzatans  = response.data.result.records;
              that.currentPage2 = response.data.result.current;
              that.total2 = response.data.result.total;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    },
    queryHyfx(){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/wenben/tWenben/list?_t='+new Date().getTime()+'&column=paixu&order=desc&field=id,biaoti,action&fenlei=行业快讯&pageNo='+this.currentPage1+'&pageSize='+this.pagesize1)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.hangyekuaixuns  = response.data.result.records;
              that.currentPage1 = response.data.result.current;
              that.total1 = response.data.result.total;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    },
    gotoXiangqing(id,activeName){
      this.$router.push({path:'/zspj',query:{id:id,type:activeName}});
    },
  }
};
</script>

<style scoped>
.nnklcv{
  display: flex;
  flex-direction: column;
  gap:1rem;
  width: 60%;
}

.tabcss55{
  width: 40%;
  display: flex;
  justify-content: start;
}
.linkcs6444{
  width: 33.33%;
  font-size: 1rem;
  color: #8a8a8a;
}
.linkcs6444:hover{
  color: #46abf5;
  cursor: pointer;
}
.middiv{
  background-color: #edf7ff;
  width: 100%;
  height: 10rem;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4rem 2rem 4rem 2rem;
}
.jjkdkfd{
  color: #137af4;
  font-weight: bold;
  font-size: 16px;
}
.mkdl{
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.tdd {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  box-shadow: 0px 0px 1px 0px #55a2da;
}
.klsd{
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
}
.tkkjk{
  font-size: 1.2rem;
  font-weight: bold;
  letter-spacing: 0.15rem;
}
.nkdlkld{
  letter-spacing: 0.15rem;
}
.midleft{
  width: 75%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.wzcss{
  letter-spacing: 1px;
  line-height: 32px;
}
.wzcss:hover{
  cursor: pointer;
  color: #137af4;
}
.midright{
  width: 25%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.xiadiv{
  width: 100%;
  display: flex;
  gap: 2rem;
}
.upcs{
  width: 100%;
  height: 8rem;
  background: -webkit-linear-gradient(bottom, #fff, #1e5de9);
  background: -moz-linear-gradient(bottom, #fff, #1e5de9);
  background: linear-gradient(to top, #fff, #1e5de9);
  display: flex;
  align-items: end;
}
.upin{
  width: 100%;
  height: 2rem;
  background-color: #373636;
  opacity: 0.5;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.neewre{
  margin: 2rem 0 2rem 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}
.neewre:hover{
  cursor: pointer;
  color: #137af4;
  text-decoration: underline;
}
</style>
